import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  catchError,
  concatMap,
  delay,
  map,
  of,
  switchMap,
  withLatestFrom,
} from 'rxjs';
import { InitService } from '../init.service';
import { InitSelectors } from '../selectors/init.selectors';

@Injectable({
  providedIn: 'root',
})
export class InitEffects {
  constructor(
    private actions$: Actions,
    private initSelectors: InitSelectors,
    private initService: InitService
  ) {}
}
